// COA files available — keyed by product slug → file extension.
// All 23 lab-tested products now have JPG test reports.
// Add new entries here when you upload a file to /app/frontend/public/coas/{slug}.{ext}
const COA_FILES = {
  'b12-10mg':         'jpg',
  'bpc-157-5mg':      'jpg',
  'bpc-157-10mg':     'jpg',
  'dsip-10mg':        'jpg',
  'ghk-50mg':         'jpg',
  'ghk-100mg':        'jpg',
  'glow-70mg':        'jpg',
  'hgh-24iu':         'jpg',
  'ipamorelin-10mg':  'jpg',
  'kisspeptin-10mg':  'jpg',
  'klow-80mg':        'jpg',
  'kpv-10mg':         'jpg',
  'lipo-d-10mg':      'jpg',
  'mots-c-10mg':      'jpg',
  'nad-1000mg':       'jpg',
  'pt-141-10mg':      'jpg',
  'reta-10mg':        'jpg',
  'selank-10mg':      'jpg',
  'semax-10mg':       'jpg',
  'snap-8-10mg':      'jpg',
  'tb-500-5mg':       'jpg',
  'tb-500-10mg':      'jpg',
  'tesamorelin-10mg': 'jpg',
};

export const AVAILABLE_COAS = new Set(Object.keys(COA_FILES));
export const hasCoa = (slug) => slug in COA_FILES;
export const coaHref = (slug) => (slug in COA_FILES ? `/coas/${slug}.${COA_FILES[slug]}` : null);
export const coaIsPdf = (slug) => COA_FILES[slug] === 'pdf';
